import * as l from "react";
import { processTypes as _ } from "./atoms-v21130.js";
import { typeOfComponent as T } from "./atoms-v21131.js";
var d = function(n, r) {
  for (var e = 0, o = r.length, p = n.length; e < o; e++, p++)
    n[p] = r[e];
  return n;
}, A = function(n, r, e) {
  for (var o, p = e === void 0 ? {} : e, v = p.customTypeKey, s = v === void 0 ? "__TYPE" : v, u = p.skipWhenFound, y = u === void 0 ? !1 : u, h = l.Children.toArray(n), f = _(Array.isArray(r) ? r : [r]), a = [], i = 0, m = h; i < m.length; i++) {
    var t = m[i], c = f.indexOf(T(t, s)) !== -1;
    c && (a = d(d([], a), [t])), !((o = t.props) === null || o === void 0) && o.children && !(y && c) && (a = d(d([], a), A(t.props.children, f, { customTypeKey: s, skipWhenFound: y })));
  }
  return a;
};
export {
  A as getChildrenByTypeDeep
};
